import { vouchersApi } from "./vouchersApi";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { VoucherReponse, VouchersReponse, CreateVoucher } from "./vouchers.interface";
import { RootState } from "@/app/store";
import { APIError, APIResponse } from "@/types/custom-http";

export const fetchVouchersSimple = createAsyncThunk<
  APIResponse<VouchersReponse>,
  void,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'vouchers/fetchVouchersSimple',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        vouchersApi.endpoints.getVouchers.initiate()
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
        return rejectWithValue({
          status,
          message: data?.message || 'Error al obtener Comprobantes de Mercadería',
          details: data.details
        });
    }
  }
);

export const fetchVouchersComplete = createAsyncThunk<
  APIResponse<VouchersReponse>,
  void,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'vouchers/fetchVouchersComplete',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        vouchersApi.endpoints.getVouchersComplete.initiate()
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
        return rejectWithValue({
          status,
          message: data?.message || 'Error al obtener Comprobantes de Mercadería',
          details: data.details
        });
    }
  }
);


export const fetchVoucherById = createAsyncThunk<APIResponse<VoucherReponse>, number,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'vouchers/fetchVoucherById',
  async (id: number, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        vouchersApi.endpoints.getVoucherById.initiate(id)
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al obtener Comprobante de Mercadería por ID',
        details: data.details
      });
    }
  }
);


export const createVoucher = createAsyncThunk<APIResponse<VoucherReponse>, CreateVoucher,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'vouchers/createVoucher',
  async (data: CreateVoucher, { dispatch, rejectWithValue }) => {
    try {
      // Disparamos la mutación y esperamos el resultado
      const result = await dispatch(
        vouchersApi.endpoints.createVoucher.initiate(data)
      ).unwrap();
      
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al crear nuevo Comprobante de Mercadería',
        details: data.details
      });
    }
  }
);